import React from "react";
// import * as IMAGES from "../Images";

import "./Loader.css";

class Loader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render = () => {
    return (
      <div className="loader-container">
        <img src="/logo.png" alt="Icon Loader" style={{ width: "325px" }} />
      </div>
    );
  };
}

export default Loader;
